import React, { useState } from 'react'
import { Accordion } from 'react-bootstrap-accordion'
import useMarketplaceStore from '../../stores/marketplaceStore'

const MarketplaceSideBar = () => {
    const { filters, setFilters } = useMarketplaceStore()

    const handleCheckboxChange = (category, value) => {
        setFilters(category, value)
    }

    const [dataCate] = useState([
        {
            title: 'Exterior',
            content: [
                { field: 'Tất cả', checked: true },
                { field: 'Factory New', checked: false },
                { field: 'Minimal Wear', checked: false },
                { field: 'Field-Tested', checked: false },
                { field: 'Well-Worn', checked: false },
                { field: 'Battle-Scarred', checked: false },
            ],
        },
        {
            title: 'Phase',
            content: [
                { field: 'Tất cả', checked: true },
                { field: 'Phase 1', checked: false },
                { field: 'Phase 2', checked: false },
                { field: 'Phase 3', checked: false },
                { field: 'Phase 4', checked: false },
                { field: 'Sapphire', checked: false },
                { field: 'Ruby', checked: false },
                { field: 'Black Pearl', checked: false },
                { field: 'Emerald', checked: false },
            ],
        },
    ])

    return (
        <div id="side-bar" className="side-bar style-3 item">
            <div className="widget widget-filter style-1 mgbt-0">
                <div className="header-widget-filter">
                    <h4 className="title-widget">Bộ lọc</h4>
                </div>
            </div>
            <div className="divider"></div>
            <div className="wrap-category">
                {dataCate.map((item, index) => (
                    <div key={index} className="widget widget-category boder-bt">
                        <Accordion title={item.title} show={true}>
                            <form action="#">
                                {item.content.map((itemm, index) => (
                                    <div key={index}>
                                        <label>
                                            <span>{itemm.field}</span>
                                            <span className="pst-re">
                                                <input
                                                    type="checkbox"
                                                    checked={filters[item.title.toLowerCase()].includes(itemm.field)}
                                                    onChange={() =>
                                                        handleCheckboxChange(item.title.toLowerCase(), itemm.field)
                                                    }
                                                />
                                                <span className="btn-checkbox"></span>
                                            </span>
                                        </label>
                                        <br />
                                    </div>
                                ))}
                            </form>
                        </Accordion>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default MarketplaceSideBar
